import Index from "../components/sections/Index";
import ErrorPage from "../Page404/ErrorPage";

export const privateRoute = [
    {
        path: "/",
        element: <Index />,
    },
    {
        path: "/*",
        element: <ErrorPage />,
    },
]